<template>
    <div class="row">
        <div class="col">
            <search></search>
            <result></result>
            <back-to-top></back-to-top>
        </div>
    </div>
</template>

<script>
    import Result from './activity-types/Result'
    import Search from './activity-types/Search'

    export default {
    
        components: {
            Search, Result
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$xapi.filters.context.loadOptions().then(() => {
                next()
            })
        }
    }
</script>
